import { useTranslation } from "react-i18next";

export default function SalaryPreview({
  model,
  mainLabel,
  index
}) {
  
  let { t } = useTranslation();
  
  return (
    <div className="salary-condition">
      <div className="salary-info">
        <div className="form-group salary-width-preview">
          <label>{t(mainLabel)}</label>
          <input
            type="number"
            id="salaryExpected"
            name="salaryExpected"
            value={model.salaryExpected || ""}
            disabled={true}
          />
        </div>
        <div className="form-group type-contract-style">
          <label>{t("Currency")}</label>
          <select
            id="expectedSalaryCurrencyId"
            className="form-select"
            name="expectedSalaryCurrencyId"
            value={model.expectedSalaryCurrency || ""}
            disabled={true}
          >
            {model.expectedSalaryCurrency ? (
                <option>
                    {model.expectedSalaryCurrency}
                </option>
            ) : (
                <option></option>
            )}
          </select>
        </div>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name={`salaryExpectedValueIsLiquid${index}`}
            id="salaryExpectedValueIsLiquidId"
            checked={model.salaryExpectedValueIsLiquid}
            disabled={true}
          />
          <label htmlFor="SalaryExpectedValueIsLiquid">{t("Liquid")}</label>
          <input
            className="form-check-input"
            type="radio"
            name={`salaryExpectedValueIsLiquid${index}`}
            id="salaryExpectedValueIsNotLiquidId"
            checked={!model.salaryExpectedValueIsLiquid}
            disabled={true}
          />
          <label htmlFor="SalaryExpectedValueIsNotLiquid">{t("Gross")}</label>
        </div>
        <div className="form-group type-contract-style">
          <label htmlFor="desiredContractType">
            {t("Desired Contract Type")}
          </label>
          <select
            id="expectedContract"
            name="expectedContract"
            className="form-select"
            value={model.expectedContractDescription || ""}
            disabled={true}
          >
            {model.expectedContractDescription ? (
                <option>
                    {model.expectedContractDescription}
                </option>
            ) : (
                <option></option>
            )}
          </select>
        </div>
      </div>
    </div>
  );
}